import * as React from "react"

import Icon from 'components/Icon'
import Link from "components/Link"

const FooterSocials = () => {
    return (
        <div className="footer-socials-container">
            <Link className="button expanded newsletter" to={'/connection-newsletter/'}>Sign up for The Connection Newsletter</Link>
            <div className="social-buttons">
                <div className="grid-container">
                    <div className="grix-x grid-padding-x align-center">
                        <div className="cell socials" style={{ display: 'flex', justifyContent: 'space-evenly', alignItems: 'center', alignContent: 'center' }}>
                            <Link className="social facebook" to={'https://www.facebook.com/waltoncountytourism/'}><Icon width={38} height={38} symbol={"facebook-circle"} foreground="#00608D" /></Link>
                            <Link className="social youtube" to={'https://www.youtube.com/@WaltonCountyTourism/'}><Icon width={38} height={38} symbol={"youtube-circle"} /></Link>
                            <Link className="social linkedIn" to={'https://www.linkedin.com/company/waltoncountytourism/'}><Icon width={38} height={38} symbol={"linkedIn-circle"} /></Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FooterSocials;
